import React from 'react';
import { makeStyles } from '@material-ui/core';
import MUIDataTable from "mui-datatables";
import TimelineIcon from '@material-ui/icons/Timeline';
import SearchIcon from '@material-ui/icons/Search';
import { MuiThemeProvider } from '@material-ui/core/styles';
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import Details from '../../../../MyLeave/component/Details'
import View from '../../../../MyTeam/component/View'
import LeaveRecordCollection from '../../../../Function/LeaveRecordCollection'
import CircularProgress from '@material-ui/core/CircularProgress';
import customAxios from "../../../../API/customAxios";
import { useIntl } from 'react-intl';
import { tableStyle, getMuiTheme } from '../../../../UIComponent/CommonStyle'
import { checkIsNewCompLeave } from '../../../../Function/globalFunction';

const useStyles = makeStyles((theme) => ({
    ...tableStyle(theme),
}));

export default function LeaveRecord({
    userId,
    employeeName,
    routing = false, 
    routingId = '',
}) {
    const classes = useStyles();
    const intl = useIntl();
    const [showCompetent, setShowCompetent] = React.useState(false);
    const [data, setData] = React.useState([]);
    const [showDetailId, setShowDetailId] = React.useState();
    const [viewId, setViewId] = React.useState();
    const [open, setOpen] = React.useState(false);
    const [openView, setOpenEdit] = React.useState(false);
    const [isNewCompLeave, setIsNewCompLeave] = React.useState(false);
    const [pageClose, setPageClose] = React.useState(false);
    const page = isNewCompLeave ? 'Comp Leave Reqs' : 'My Leave';

    React.useEffect(() => {
        if (routing) {
            setViewId(routingId);
            setOpenEdit(routing);
            setIsNewCompLeave(true);
            setPageClose(true);
        }
    }, [routing]);

    React.useEffect(() => {
        if (!routing) {
            customAxios.get(`/get_employee_leave/` + userId)
            .then(res => {
                var getLeaveRecord = res.data;
                setData(LeaveRecordCollection(getLeaveRecord, 'LeaveRecord', intl));
                setShowCompetent(true);
            })
        }
    }, [routing]);

    const handleOpen = (id, isNewCompLeave) => {
        setShowDetailId(id)
        setIsNewCompLeave(isNewCompLeave);
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const handleOpenEdit = (id, isNewCompLeave) => {
        setViewId(id)
        setIsNewCompLeave(isNewCompLeave);
        setOpenEdit(true);
    };
    const handleCloseEdit = () => {
        setOpenEdit(false);
    };

    const options = {
        filterType: 'checkbox',
        elevation: 1,
        print: false,
        search: false,
        selectableRows: 'none',
        textLabels: {
            body: {
                noMatch: 'No matching records found',
            },
        },
    };
    const columns = [
        {
            name: "id",
            label: "ID",
            options: {
                filter: true,
                sort: true,
                filterType: "textField",
            }
        },
        {
            name: "type",
            label: "Leave Type",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "dateSubmitted",
            label: "Date Submitted",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "startDate",
            label: "From",
            options: {
                filter: false,
                sort: false,
            }
        },
        {
            name: "untilDate",
            label: "To",
            options: {
                filter: false,
                sort: false,
            }
        },
        {
            name: "period",
            label: "Day(s)",
            options: {
                filter: false,
                sort: false,
            }
        },
        {
            name: "status",
            label: "Status",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "progress",
            label: "Progress",
            options: {
                filter: false,
                sort: false,
                empty: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <TimelineIcon 
                            onClick={() => {
                                const isNewCompLeave = checkIsNewCompLeave(tableMeta.rowData[3]);
                                handleOpen(tableMeta.rowData[0], isNewCompLeave);
                            }} 
                            className={classes.muiDataTableIcon} 
                        />
                    );
                }
            }
        },
        {
            name: "details",
            label: "Details",
            options: {
                filter: false,
                sort: false,
                empty: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <SearchIcon 
                            onClick={() => {
                                const isNewCompLeave = checkIsNewCompLeave(tableMeta.rowData[3]);
                                handleOpenEdit(tableMeta.rowData[0], isNewCompLeave);
                            }} 
                            className={classes.muiDataTableIcon} 
                        />
                    );
                }
            }
        },
    ];

    return (
        <main className={classes.content}>
            {showCompetent ?
                <MuiThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                        title={employeeName}
                        data={data}
                        columns={columns}
                        options={options}
                    />
                </MuiThemeProvider>
                :
                <div className={classes.circularProgress}>
                    <CircularProgress />
                </div>
            }
            {open && 
                <Details 
                    handleClose={handleClose} 
                    open={open} 
                    showId={showDetailId} 
                    page={page} 
                    isNewCompLeave={isNewCompLeave}>
                </Details>
            }
            {openView && 
                <View 
                    handleClose={handleCloseEdit} 
                    open={openView} 
                    showId={viewId} 
                    backToTable={handleCloseEdit} 
                    isNewCompLeave={isNewCompLeave}
                    pageClose={pageClose}
                />
            }
        </main>
    );
}
